module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-appscenariobg.e1b19674.png";